module.exports = __webpack_public_path__ + "img/SKMJ_lift4.9ee76d5a.jpg";